Core.ResellerRouter = Core.SubRouter.extend({
    routes: {
        '': 'customers',
        'signup': 'signup',
        'customers': 'customers',
    },

    signup: function () {
        debug.log('reseller signup');
        app.setMainView(new ResellerSignupView(), 'reseller');
    },

    customers: function () {
        debug.log('reseller customers');
        app.setMainView(new ResellerCustomerListView(), 'reseller');
    },

});
